var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, when, makeObservable } from 'mobx';
import { AttachedTrait } from '../attachedtrait/AttachedTrait';
import { actionRegistry, eventRegistry } from '../../../registry/Registry';
import { uniq } from '../../../utils/helper/lodash_replacements';
import { getEventClass } from '../../event/getEventClass';
import { runtime } from '../../runtime/Runtime';
export class AttachedActionTrait extends AttachedTrait {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get actionReg() {
        return actionRegistry.registry_object[this.trait.value];
    }
    get aspectsTemplate() {
        const aspectsTemplate = super.aspectsTemplate;
        mergeIntoAspectsTemplate(this.reg.aspectsTemplate, aspectsTemplate);
        if (this.actionReg && this.actionReg.params) {
            mergeIntoAspectsTemplate(this.actionReg.params, aspectsTemplate);
        }
        return aspectsTemplate;
    }
    async fireEvent() {
        await when(() => this.context.app.appBoot.isInteractive);
        const type = eventRegistry.typeByHandlerName(this.key);
        const EventClass = getEventClass(type);
        const event = new EventClass({ rawEvent: { type }, actionAt: this });
        await this.handleEvent(event); // EventRegistryObject[K]['EventClassType'
    }
    async handleEvent(event) {
        const packageName = (this.trait.value || '').split('_')[0];
        if (['Plugin', 'Exotic', 'Lazy', 'Rare', 'Grundschule', 'Layout', 'Draft'].includes(packageName)) {
            await runtime.fetchPackages[packageName];
        }
        if (this.actionReg) {
            event.eventAttachedAction.currentActionAt = this;
            this.actionReg.action(event.eventAttachedAction.context);
        }
    }
}
__decorate([
    action.bound
], AttachedActionTrait.prototype, "handleEvent", null);
export function mergeIntoAspectsTemplate(source = {}, target) {
    Object.keys(source).map((key) => {
        if (!target[key]) {
            target[key] = [];
        }
        target[key] = uniq([...target[key], ...source[key]]);
    });
    return target;
}
